<template>
  <div class="product-detail-join-vip-highlight-bar">
    <row-bar v-if="showSecondaryBtn"
             :type="secondaryJoin.type || 'black-gold'"
             :price="secondaryJoin"
             @click="handleClickSecondary"
    />

    <row-bar :type="primaryJoin.type || 'gold-black'"
             :price="primaryJoin"
             :show-delete="false"
             @click="handleClickPrimary"
    />
  </div>
</template>

<script>
  import RowBar from '@/components/ProductDetailBottom/components/ActionRowBar';

  export default {
    name: 'ProductDetailBottomVipHighlightJoinBar',
    components: {
      RowBar,
    },
    props: {
      buttons: {
        type: Array,
        required: true,
      },
    },
    computed: {
      primaryJoin() {
        return this.buttons.find((item, index) => index === 0);
      },
      secondaryJoin() {
        return this.buttons.find((item, index) => index === 1);
      },
      showSecondaryBtn() {
        return this.buttons.length > 1;
      },
    },
    methods: {
      handleClickPrimary(product) {
        this.$emit('click-primary', product);
      },
      handleClickSecondary(product) {
        this.$emit('click-secondary', product);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-join-vip-highlight-bar {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
